import ReactDOM from "react-dom/client";
import { App } from "./app";

const root = ReactDOM.createRoot(document.getElementById("app-root") as HTMLElement);

root.render(<App />);
